/**
* modals.js
*
* Contains helper functions necessary for the
* modal functionality
*/

import "../libraries/growl"

$(function () {

  var activeInterval = setInterval(function () {
    var $btns = $('.btn.modal-iframe:not(.max-booking)');
    if ($.active) {
      $btns.addClass('loading').off('click.shhh').on('click.shhh', function (e) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      });
      var loadingOverlay = $('<div class="loadingOverlay" style="background:transparent;"><div class="spinner" /></div>');
      $btns.find('.loadingOverlay').remove();
      $btns.append(loadingOverlay);
    } else {
      $btns.removeClass('loading').off('click.shhh');
      $btns.find('.loadingOverlay').remove();
      clearInterval(activeInterval);
    }
  }, 500);

  /* iframe modals */
  $(document.body).on('click', '.modal-iframe:not(.max-booking)', function (e) {
    $(this).imodal();
    e.preventDefault();
  })

  /* open bootstrap modal programmatically */
  window.dialog = function (url, nested) {
    if (url) {
      var $remote = $('<div class="modal-iframe" href="' + url + '" data-fullscreen="true" ' + (nested ? 'data-nested="true"' : '') + ' style="display:none"></div>');
      $(document.body).append($remote);
      $remote.trigger('click');
      $remote.remove();
    }
  };

  // close modal buttons
  $(document.body).on('click', '[data-dismiss="modal"]', function () {
    parent.hide_modal();
  });

  window.hide_modal = function () {
    $('.modal').modal('hide');
  };

  // stop nav a tag propagation
  $(document.body).on('click', '.nav-tabs li a', function (e) {
    e.preventDefault();
    e.stopPropagation();
  })

  /* refresh data (usually called by a model after its data changes) */
  function get_data_table_modal_body(elements) {
    var element, e;

    for (e in elements) {
      element = $(elements[e]);
      if (element.hasClass('modal-body')) {
        return element.html();
      }
    }
  }

  window.refresh_data = function (msg) {

    window.form_changed = false;

    if (typeof window.refresh_data_table == 'function') {
      window.refresh_data_table();
    } else {
      $(window).trigger('refresh_data_table');
    }

    if (typeof window.refresh_cal == 'function') {
      window.refresh_data_table();
    } else {
      $(window).trigger('refresh_cal');
    }

    if (typeof window.refresh_relations == 'function') {
      window.refresh_relations();
    } else {
      $(window).trigger('refresh_relations');
    }

    /* refresh your parent's data, if you have one */
    if (window.location !== window.parent.location && typeof window.parent.refresh_data == 'function') {
      window.parent.refresh_data(msg);
    }

    if (msg && typeof msg == 'string' && window.location === window.parent.location) {
      $.bootstrapGrowl(msg, {type: 'success'});
    }

    if (typeof msg != 'string' && typeof parent.custom_refresh_data == 'function') {
      parent.custom_refresh_data(msg);
    }
  };

});
